import Vue from 'vue'
import ListaVazia from '@/shared/components/crud/lista/ListaVazia'
import BuscaVazia from '@/shared/components/crud/lista/BuscaVazia'

// Estado vazio e busca sem resultado do novo layout, globais (2026-09-13, "esses componentes
// podem ser globais"): qualquer tela usa <lista-vazia> e <busca-vazia> sem importar. O mixin
// Lista continua registrando os mesmos componentes localmente, então nada muda para quem já usa.
Vue.component('lista-vazia', ListaVazia)
Vue.component('busca-vazia', BuscaVazia)
